import React from 'react';
// import './footer.css';

function Footer() {
    return (
        <div>
            <footer >
                {/* footer */}
            </footer>
        </div>
    );
}

export default Footer;
